.quantityButton {
  width: 100%;
  margin-left: auto;
}

.cartDrawerItem {
  overflow: visible;
  padding-left: 8px;
  padding-right: 8px;
}

@media (--reefer-media-tablet-min) {
  .cartDrawerItem {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.productDetailsContainer {
  cursor: pointer;
}

.capitalizeText {
  text-transform: capitalize;
}
